var map = {
	"./i18n/en-us.json": [
		65364,
		"libs_shared_feature_warning-bars_src_lib_warning-bar_i18n_en-us_json"
	],
	"./i18n/es-es.json": [
		67442,
		"libs_shared_feature_warning-bars_src_lib_warning-bar_i18n_es-es_json"
	],
	"./i18n/pt-br.json": [
		30642,
		"libs_shared_feature_warning-bars_src_lib_warning-bar_i18n_pt-br_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 56167;
module.exports = webpackAsyncContext;